import ApiBase from "../api-base";
import axios from "axios";


class UsersApi extends ApiBase {

    async roles(page = 1, perPage = 100) {
        const response = await  this.get('/roles');
        return response.data;
    }

    async register(params, validationCallback = this.defaultValidationHandler) {

        return await this.post('/registration', params, validationCallback);

    }

    async getUser(id) {
        const response = await this.get('/users/' + id);
        return response.data;
    }

}


export default new UsersApi();
